import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css";
import { Provider as AlertProvider } from "react-alert";

import { AlertTemplate, options } from "./components/alert";

ReactDOM.render(
  <React.StrictMode>
    <AlertProvider template={AlertTemplate} {...options}>
      <App />
    </AlertProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
